import { useParams } from 'react-router-dom'
import _ from 'lodash'

import {
  LoadingContainer,
  Panels,
  Bar,
  Modal,
  ModelList,
  Pagination,
} from 'peach/components'
import { humanizeKey } from 'peach/helpers'

import { Page } from 'core/components'
import { useQueryString } from 'core/hooks'
import { useListCasesByBorrower, useCreateCase, PickRequired } from 'core/types'
import { ListCasesByBorrowerVariables } from 'core/types/operations'

import CreateCaseForm from './CreateCaseForm'

const defaultCase = { metaData: {} }

const PersonCases = () => {
  const { personId } = useParams<{ personId?: string }>()

  const [query, setQuery] = useQueryString<
    PickRequired<
      NonNullable<ListCasesByBorrowerVariables['query']>,
      'limit' | 'offset'
    >
  >({
    limit: 50,
    offset: 0,
  })

  const {
    data: cases,
    pagination: { total: count } = {},
    isLoading,
    error,
  } = useListCasesByBorrower({
    personId,
    query,
  })

  const { mutateAsync: createCase } = useCreateCase({ personId })

  const sortedCases = _.sortBy(cases ?? [], 'createdAt').reverse()

  const casesByType = _.groupBy(sortedCases, 'caseType')

  return (
    <Panels
      header={
        <Bar
          left={
            <Pagination
              limit={query.limit ?? 0}
              maxPagesVisible={16}
              offset={query.offset ?? 0}
              onChange={(offset) => setQuery({ offset })}
              total={count}
            />
          }
          title='All Cases'
        />
      }
    >
      <Modal
        initialValue={defaultCase}
        onSubmit={async (personCase) =>
          await createCase({
            ...personCase,
            query: { validate: false },
          })
        }
        title='Create Case'
      >
        <CreateCaseForm />
      </Modal>
      <LoadingContainer error={error} loading={isLoading}>
        <Page variant='full'>
          {_.map(casesByType, (group, key) => (
            <ModelList
              json={group}
              key={key}
              title={`${humanizeKey(key)} Cases`}
            />
          ))}
        </Page>
      </LoadingContainer>
    </Panels>
  )
}

export default PersonCases
